import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Sign } from '../_models/sign';
import { MockAuthService } from '../_services/_mocks/mockAuthService';

@Component({
  standalone: false,
  selector: 'app-driver-signature',
  templateUrl: './driver-signature.component.html',
  styleUrls: ['./driver-signature.component.scss']
})
export class DriverSignatureComponent implements OnInit {
  // Objetos //
  currentSign;
  
  // Booleanos //
  signed: boolean = false;

  // Datos entre Componentes //

  @Input() isTenarisDestination: boolean = false;
  @Input() signList: Array<Sign> = [];
  @Output() sendSign = new EventEmitter<object>();


  constructor(public mockAuthService: MockAuthService,
    private modalService: NgbModal) { }
  
  ngOnInit(): void {}
  
  createSign(content, current) {
    this.signed = false;
    this.currentSign = current; //currentsign.type
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  getSign(data: Sign){
    this.sendSign.emit(data);
  }

}

